import React, { useState, useEffect } from 'react';
import axios from 'axios';
import InfoForm from './form/InfoForm';
import useEndpoints from '../../API/apiConfig';
import LoadingSpinner from './UI/LoaderSpinner';

export default function InfoManager() {
    const endpoints = useEndpoints();
    const [posts, setPosts] = useState([]);
    const [currentPost, setCurrentPost] = useState(null);
    const [isLoading, setIsloading] = useState(true);
    console.log(currentPost)
    const user = JSON.parse(localStorage.getItem('user'));
    const token = user?.data?.token;

    const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    const fetchPosts = async () => {
        const response = await axios.get(`${endpoints.INFO}`, { headers });
        setPosts(response.data);
        setIsloading(false);
    };

    const createPost = async (data) => {
        try {
            await axios.post(`${endpoints.INFO_ADD}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
            fetchPosts();
        } catch (error) {
            console.error("Error creating poster:", error);
        }
    };

    const updatePost = async (data) => {
        await axios.post(`${endpoints.INFO_UPDATE}`, data, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        });
        fetchPosts();
    };

    const deletePost = async (id) => {
        await axios.delete(`${endpoints.INFO_DELETE}?id=${id}`, { headers });
        fetchPosts();
    };

    const resetCurrentItem = () => {
        setCurrentPost(null)
    }
    useEffect(() => {
        fetchPosts();
    }, []);

    return (
        <section className='manager'>
            <h1 className='manager__title'>Управление постами</h1>
            <InfoForm post={currentPost} onSubmit={currentPost ? updatePost : createPost} resetCurrentPost={resetCurrentItem} />
            <h2 className='manager__title_h2'>Список постов</h2>
            {isLoading ? (
                <LoadingSpinner />
            ) : (
                <ul className='manager__ul'>
                    {posts.map(post => (
                        <li className='manager__li' key={post.idPoster}>
                            {post.description}
                            <div>
                                <button className='manager__button' onClick={() => setCurrentPost(post)}>Редактировать</button>
                                <button className='manager__button' onClick={() => deletePost(post.idInfo)}>Удалить</button>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </section>
    );
}